import { ChangeDetectionStrategy, Component } from '@angular/core'
import { Header } from '@core/components/header/header'
import { Toast } from '@core/components/toast/toast'
import { Navigation } from '@core/navigation/navigation'
import { RouterOutlet } from '@angular/router'
@Component({
  selector: 'bo-root',
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Header, Toast, Navigation, RouterOutlet],
})
export class App {}
